import _ from 'lodash';
import React from 'react';

// Supermove
import {Space} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {OrganizationModel} from '@supermove/models';

// App
import Text from '@shared/design/components/Text';
import CallrailIntegrationMode from '@shared/modules/CallrailIntegration/enums/CallrailIntegrationMode';
import {FormikSetupCallrailIntegrationFormType} from '@shared/modules/CallrailIntegration/forms/SetupCallrailIntegrationForm';
import JobTypeDropdown from '@shared/modules/Project/components/JobTypeDropdown';
import ProjectTypeDropdown from '@shared/modules/Project/components/ProjectTypeDropdown';

interface CallrailProjectSettingsFieldsProps {
  form: FormikSetupCallrailIntegrationFormType;
  field: string;
  organization: OrganizationModel;
}

const CallrailProjectSettingsFields = ({
  form,
  field,
  organization,
}: CallrailProjectSettingsFieldsProps) => {
  const mode = _.get(form.values, `${field}.mode`);
  const isCreateCallsMode = mode === CallrailIntegrationMode.CREATE_CALLS;
  const projectTypeId = _.get(form.values, `${field}.projectTypeId`);

  if (!isCreateCallsMode) {
    return (
      <Text.Subheading>
        Project settings are only required for 'Create calls' mode. You can proceed to the next
        step.
      </Text.Subheading>
    );
  }

  return (
    <React.Fragment>
      <ProjectTypeDropdown
        organization={organization}
        form={form}
        field={field}
        jobFormField={field}
        isRequired={isCreateCallsMode}
      />
      <Space height={16} />
      <JobTypeDropdown
        organization={organization}
        form={form}
        field={field}
        projectTypeId={projectTypeId}
        isRequired={isCreateCallsMode}
      />
    </React.Fragment>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
CallrailProjectSettingsFields.fragment = gql`
  ${ProjectTypeDropdown.fragment}
  ${JobTypeDropdown.fragment}

  fragment CallrailProjectSettingsFields on Organization {
    id
    ...ProjectTypeDropdown
    ...JobTypeDropdown
  }
`;

export default CallrailProjectSettingsFields;
